// @ts-nocheck
import { takeEvery, call, put, select } from 'redux-saga/effects'
import { stopSubmit, reset } from 'redux-form/immutable'
import { uniq } from 'lodash'
import i18next from 'i18next'

import makeAPIRequest, { getResponseBody, getResponseData } from 'store/entities/api/sagas'
import { modal } from 'store/entities/modal/actions'
import BulkManagementPopup from 'app/domains/common/AdminAndSuperAdminComponents/BulkManagement/BulkManagementPopup'
import { getSelectedProTrackLevelForSelectedOrganization } from 'store/entities/organizations/selectors.ts'
import { parseEmails } from 'helpers/parseInvites.js'
import { FORM_NAME } from 'app/domains/common/AdminAndSuperAdminComponents/BulkManagement/BulkManagementForm'
import isEmail from 'helpers/isEmail'
import { BULK_MANAGEMENT_FORM_TYPE } from 'app/constants/bulkManagement'
import { manageUsers } from 'store/entities/organizations/actions'
import { getManageUsersUrl } from 'helpers/bulkManagement'

function* handleManageUsers({ payload: { data, formType } }) {
  try {
    let errors: any = { emails: [] }
    if (data.emails.length) {
      data.emails = parseEmails(data.emails)
      data.emails = uniq(data.emails)
      data.emails = data.emails.reduce((acc: any, email: any) => {
        const newEmail = email.replace(',', '').trim()
        if (isEmail(newEmail)) {
          acc.push(newEmail)
        } else {
          errors.emails.push(newEmail)
        }
        return acc
      }, [])
    } else {
      data.emails = []
    }
    if (errors.emails.length) {
      errors.emails = errors.emails.toString().replace(',', '\n')
      yield put(stopSubmit(FORM_NAME, errors))
    } else {
      const url = getManageUsersUrl(formType, data.organizationId)
      const response = yield call(makeAPIRequest, url, {
        method: formType === BULK_MANAGEMENT_FORM_TYPE.DELETE_USERS ? 'DELETE' : 'POST',
        data: data,
      })
      const dataResponse = getResponseData(getResponseBody(response))
      if (dataResponse) {
        yield put(reset(FORM_NAME))
        let propsForPopup: any = null
        if (formType === BULK_MANAGEMENT_FORM_TYPE.SWITCH_PROTRACK) {
          const proTrackLevel = yield select(getSelectedProTrackLevelForSelectedOrganization(data.proTrackLevelId))
          propsForPopup = {
            title: i18next.t('admin:ProHabits Confirmation of ProTrack Switch'),
            subtitle: `${i18next.t(
              'admin:participants were successfully moved to proTrackLevelName and will receive the first microaction for that track on the next business day',
              {
                successfulCount: dataResponse.successfulCount,
                proTrackLevelName: `${proTrackLevel.proTrack.name} - ${proTrackLevel.name}`,
              }
            )}. ${i18next.t('admin:participants switching failed', { failedCount: dataResponse.failedCount })}.`,
            titleFirstTable: i18next.t('admin:The following participants were moved'),
            titleSecondTable: i18next.t('admin:The following participants were not moved and should be investigated'),
            successfulCount: dataResponse.successfulCount,
            failedCount: dataResponse.failedCount,
          }
        } else if (formType === BULK_MANAGEMENT_FORM_TYPE.STOP_PROTRACK) {
          propsForPopup = {
            title: i18next.t('admin:ProHabits Confirmation of Stopped ProTracks'),
            subtitle: `${i18next.t('admin:participants were successfully stopped', {
              successfulCount: dataResponse.successfulCount,
            })}. ${i18next.t('admin:participants were not stopped', { failedCount: dataResponse.failedCount })}.`,
            titleFirstTable: i18next.t('admin:The following participants were stopped'),
            titleSecondTable: i18next.t('admin:The following participants were not stopped and should be investigated'),
            successfulCount: dataResponse.successfulCount,
            failedCount: dataResponse.failedCount,
          }
        } else {
          propsForPopup = {
            title: i18next.t('admin:ProHabits Confirmation of Deleted Users'),
            subtitle: `${i18next.t('admin:users were successfully deleted', {
              successfulCount: dataResponse.successfulCount,
            })}. ${i18next.t('admin:users were not deleted', { failedCount: dataResponse.failedCount })}.`,
            titleFirstTable: i18next.t('admin:The following users were deleted'),
            titleSecondTable: i18next.t('admin:The following users were not deleted and should be investigated'),
            successfulCount: dataResponse.successfulCount,
            failedCount: dataResponse.failedCount,
          }
        }
        yield put(
          modal.show(BulkManagementPopup, {
            size: 'stretch',
            data: dataResponse,
            important: true,
            ...propsForPopup,
          })
        )
      }
    }
  } catch (badResponse) {
    console.log(badResponse)
  }
}

export default function* manageUsersSaga() {
  yield takeEvery(manageUsers, handleManageUsers)
}
